import React, { useState, useEffect } from "react";
import { Button, FormControl, Form } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
const API_URL = process.env.REACT_APP_API_URL;

function PIWILmRNA() {
    const sampleCode = useSelector((state) => state.sample.code);

    const { sample_id } = useParams();

    const [formData, setFormData] = useState({
        mena_id: "",
        sample_id: "",
        piwil1_avg: "",
        piwil2_avg: "",
        piwil3_avg: "",
        piwil4_avg: "",
        piwil1_copies: "",
        piwil2_copies: "",
        piwil3_copies: "",
        piwil4_copies: "",
        piwil1_slope: "",
        piwil2_slope: "",
        piwil3_slope: "",
        piwil4_slope: "",
        piwil1_intercempt: "",
        piwil2_intercempt: "",
        piwil3_intercempt: "",
        piwil4_intercempt: "",
        remark: "",

    });

    const calculateCopies = (avg, slope, intercept) => {
        const a = parseFloat(avg);
        const m = parseFloat(slope);
        const b = parseFloat(intercept);

        if (isNaN(a) || isNaN(m) || isNaN(b) || m === 0) {
            return "";
        }

        const value = Math.pow(10, (a - b) / m);
        return Number(value.toFixed(3)); // 3 decimal precision
    };

    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            piwil1_copies: calculateCopies(prev.piwil1_avg, prev.piwil1_slope, prev.piwil1_intercempt),
            piwil2_copies: calculateCopies(prev.piwil2_avg, prev.piwil2_slope, prev.piwil2_intercempt),
            piwil3_copies: calculateCopies(prev.piwil3_avg, prev.piwil3_slope, prev.piwil3_intercempt),
            piwil4_copies: calculateCopies(prev.piwil4_avg, prev.piwil4_slope, prev.piwil4_intercempt),
        }));
    }, [
        formData.piwil1_avg,
        formData.piwil1_slope,
        formData.piwil1_intercempt,
        formData.piwil2_avg,
        formData.piwil2_slope,
        formData.piwil2_intercempt,
        formData.piwil3_avg,
        formData.piwil3_slope,
        formData.piwil3_intercempt,
        formData.piwil4_avg,
        formData.piwil4_slope,
        formData.piwil4_intercempt,
    ]);


    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!sample_id) return;

        const fetchData = async () => {
            try {
                const res = await axios.get(`${API_URL}/piwil-mrna/${sample_id}`);

                if (res.data?.status && res.data?.PiwilMrnaModel) {
                    setFormData(prev => ({
                        ...prev,
                        ...res.data.PiwilMrnaModel
                    }));
                }
            } catch (error) {
                console.error("Fetch error:", error);
            }
        };

        fetchData();
    }, [sample_id]);




    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.mena_id) {
            alert("Data not loaded yet");
            return;
        }

        const token = localStorage.getItem("token");



        try {
            const res = await axios.put(
                `${API_URL}/piwil-mrna-update/${formData.mena_id}`,
                formData,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            // alert(res.data.message || "Saved successfully");

            setSuccessMsg(
                res.data.message || `PIWIL mRNA Expression data saved successfully`
            ); setErrorMsg("");

            setTimeout(() => setSuccessMsg(""), 1000);

        } catch (err) {
            console.error(err);
            setErrorMsg("Save failed");
        }
    };



    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };







    const inputStyle = {
        width: "120px",
        height: "35px",
        border: "2px solid #001A43",
        borderRadius: "4px",
        margin: "5px"
    };

    const labelStyle = {
        backgroundColor: "#DFF5F1",
        padding: "6px 12px",
        margin: "8px 0",
        borderRadius: "6px",
        display: "inline-block",
        border: "1px solid #4DB6AC"
    };
    const copiesInputStyle = {
        width: "120px",
        height: "35px",
        border: "2px solid #001A43",
        borderRadius: "4px",
        margin: "5px",
        backgroundColor: "#E8F0FF"
    }; const gridStyle = {
        display: "grid",
        gridTemplateColumns: "180px 140px 160px 180px 140px 160px",
        rowGap: "14px",
        columnGap: "20px",
        alignItems: "center"
    };
    return (

        <div>
            <h6 style={{ textAlign: "left" }}>PIWIL mRNA Expression</h6>

            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}

            <Form onSubmit={handleSubmit}>


                <div style={gridStyle}>

                    {/* Header row */}
                    <div></div>
                    <div style={labelStyle}>Avg Ct</div>
                    <div style={labelStyle}>Copies of mRNA</div>
                    <div></div>
                    <div style={labelStyle}>Slope (m)</div>
                    <div style={labelStyle}>Y intercept (b)</div>

                    {/* PIWIL 1 */}
                    <div style={labelStyle}>PIWIL 1 mRNA</div>
                    <FormControl type="number" name="piwil1_avg" style={inputStyle} value={formData.piwil1_avg ?? ""} onChange={handleChange} />
                    <FormControl type="number" name="piwil1_copies" style={copiesInputStyle} value={formData.piwil1_copies ?? ""} readOnly />
                    <div style={labelStyle}>PIWIL 1 Std</div>
                    <FormControl type="number" name="piwil1_slope" style={inputStyle} value={formData.piwil1_slope ?? ""} onChange={handleChange} />
                    <FormControl type="number" name="piwil1_intercempt" style={inputStyle} value={formData.piwil1_intercempt ?? ""} onChange={handleChange} />

                    {/* PIWIL 2 */}
                    <div style={labelStyle}>PIWIL 2 mRNA</div>
                    <FormControl type="number" name="piwil2_avg" style={inputStyle} value={formData.piwil2_avg ?? ""} onChange={handleChange} />
                    <FormControl type="number" name="piwil2_copies" style={copiesInputStyle} value={formData.piwil2_copies ?? ""} readOnly />
                    <div style={labelStyle}>PIWIL 2 Std</div>
                    <FormControl type="number" name="piwil2_slope" style={inputStyle} value={formData.piwil2_slope ?? ""} onChange={handleChange} />
                    <FormControl type="number" name="piwil2_intercempt" style={inputStyle} value={formData.piwil2_intercempt ?? ""} onChange={handleChange} />

                    {/* PIWIL 3 */}
                    <div style={labelStyle}>PIWIL 3 mRNA</div>
                    <FormControl type="number" name="piwil3_avg" style={inputStyle} value={formData.piwil3_avg ?? ""} onChange={handleChange} />
                    <FormControl type="number" name="piwil3_copies" style={copiesInputStyle} value={formData.piwil3_copies ?? ""} readOnly />
                    <div style={labelStyle}>PIWIL 3 Std</div>
                    <FormControl type="number" name="piwil3_slope" style={inputStyle} value={formData.piwil3_slope ?? ""} onChange={handleChange} />
                    <FormControl type="number" name="piwil3_intercempt" style={inputStyle} value={formData.piwil3_intercempt ?? ""} onChange={handleChange} />

                    {/* PIWIL 4 */}
                    <div style={labelStyle}>PIWIL 4 mRNA</div>
                    <FormControl type="number" name="piwil4_avg" style={inputStyle} value={formData.piwil4_avg ?? ""} onChange={handleChange} />
                    <FormControl type="number" name="piwil4_copies" style={copiesInputStyle} value={formData.piwil4_copies ?? ""} readOnly />
                    <div style={labelStyle}>PIWIL 4 Std</div>
                    <FormControl type="number" name="piwil4_slope" style={inputStyle} value={formData.piwil4_slope ?? ""} onChange={handleChange} />
                    <FormControl type="number" name="piwil4_intercempt" style={inputStyle} value={formData.piwil4_intercempt ?? ""} onChange={handleChange} />

                </div>
                <div className="mb-3">
                    <FormControl
                        as="textarea" name="remark"
                        rows={2} value={formData.remark ?? ""} onChange={handleChange}
                        placeholder="Enter remarks here"
                        style={{ width: "1000px", marginTop: "30px" }}
                    />
                </div>

                <div className="d-flex justify-content-center mt-4">
                    <Button
                        type="submit"
                        variant="primary"
                        className="px-4 mb-4"
                    >
                        Save
                    </Button>
                </div>
            </Form >
        </div>


    );
}

export default PIWILmRNA;